import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { StatusMotorista } from 'src/app/models/status-motorista.model';

@Injectable()
export class PreCheckoutComponenteService {

  error = new BehaviorSubject<StatusMotorista>(
    new StatusMotorista()
  );

  public set(error: StatusMotorista): void {
    this.error.next(error);
  }

  public get(): Observable<StatusMotorista> {
    return this.error.asObservable();
  }
}
